module.exports = __webpack_public_path__ + "media/images/logo-navbar-2a4277829662b95f060bcac0c01db050.svg";